var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wp-side-menu-bar" } },
    [
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "integration" },
          attrs: { to: "/integrations/whatsapp" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("chatbotv2.integration")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "contact-list" },
          attrs: { to: "/integrations/whatsapp/contact-list" },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("wp.contactList")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu",
          class: { active: _vm.selectedPage === "broadcast" },
          attrs: { to: "/integrations/whatsapp/broadcast/requests" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("wp.broadcast.broadcast")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "broadcast",
            active: _vm.selectedSubPage === "requests",
          },
          attrs: { to: "/integrations/whatsapp/broadcast/requests" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("wp.broadcastRequests")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "broadcast",
            active: _vm.selectedSubPage === "customer-groups",
          },
          attrs: { to: "/integrations/whatsapp/broadcast/customer-groups" },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("wp.customerGroups")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "menu sub-menu",
          class: {
            hidden: _vm.selectedPage !== "broadcast",
            active: _vm.selectedSubPage === "message-templates",
          },
          attrs: { to: "/integrations/whatsapp/broadcast/message-templates" },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("wp.messageTemplates")) + "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }